import { createRouter, createWebHistory } from 'vue-router'
import store from './store/index.js'
import goSectionMixin from './mixins/goSectionMixin.js';

const Novedad = () => import(/* webpackChunkName: "Novedades" */'./pages/Novedad.vue');
const Novedades = () => import(/* webpackChunkName: "Novedades" */'./pages/Novedades.vue');
const Articulo = () => import(/* webpackChunkName: "Entradas" */'./pages/Articulo.vue');
const Proyecto = () => import(/* webpackChunkName: "Entradas" */'./pages/Proyecto.vue');
//const Proyectos = () => import(/* webpackChunkName: "Entradas" */'./pages/Proyectos.vue');
const Inicio = () => import(/* webpackChunkName: "InicioPage" */'./pages/Inicio.vue');
const Recreacion = () => import(/* webpackChunkName: "recreacion" */'./pages/Recreacion.vue');
const NotFound = () => import(/* webpackChunkName: "NotFound" */'./pages/NotFound.vue');
const Encuentro2022 = () => import(/* webpackChunkName: "Encuentro" */'./pages/Encuentro.vue');
const Encuentro2024 = () => import(/* webpackChunkName: "Encuentro" */'./pages/Encuentro2024.vue');
const Encuentro2026 = () => import(/* webpackChunkName: "Encuentro" */'./pages/Encuentro2026.vue');
const Nosotrxs = () => import(/* webpackChunkName: "Nosotrxs" */'./pages/Nosotrxs.vue');
const Ludiculas = () => import(/* webpackChunkName: "Luderia" */'./pages/Ludiculas.vue');
const Ludicula = () => import(/* webpackChunkName: "Luderia" */'./pages/Ludicula.vue');
const Luderia = () => import(/* webpackChunkName: "Luderia" */'./pages/Luderia.vue');

let url 

//FIXME al subir cambiar
//Local
// if (store.state.subcarpeta != "") {
//   url = "/abriendo-el-juego/"+ store.state.subcarpeta + "/"
// } else {
//   url = "/abriendo-el-juego/"
// }

//Servidor
if (store.state.subcarpeta != "") {
  url = "/"+ store.state.subcarpeta + "/"
} else {
  url = "/"
}

//console.log("router", url)

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { 
      path: url,
      name: 'inicio',
      component: Inicio, 
      props: true,
    },
    { 
      path: url +'quienes-somos/', 
      name: 'nosotrxs', 
      component: Nosotrxs 
    }, 
    { 
      path: url +'recreacion/:slug', 
      name: 'recreacion',
      component: Recreacion,
    },
    { 
      path: url +'recreacion', 
      redirect: { name: 'inicio' }
    },
    { 
      path: url +'novedades/:slug', 
      name: 'novedad',
      component: Novedad,
      props: true      
    },
    { 
      path: url +'novedades', 
      name: 'novedades',
      component: Novedades,
      props: true      
    },
    { 
      path: url +'novedades/page/:number', 
      name: 'novedadesPage',
      component: Novedades,
      props: true      
    },
    { 
      path: url +'caminos/encuentro', 
      redirect: { name: 'encuentro' }
    },
    { 
      path: url +'encuentro2024', 
      name: 'encuentro2024', 
      component: Encuentro2024, 
      props: true, 
    },
    { 
      path: url +'encuentro2026', 
      name: 'encuentro2026', 
      component: Encuentro2026, 
      props: true, 
    },
    { 
      path: url +'encuentro2022', 
      name: 'encuentro2022', 
      component: Encuentro2022, 
      props: true, 
    },
    { 
      path: url +'encuentro', 
      redirect: { name: 'encuentro2026' }
    },
    { 
      path: url +'caminos/luderia', 
      redirect: { name: 'luderia' }
    },
    { 
      path: url +'caminos/:slug', 
      name: 'proyecto',
      component: Proyecto,
      props: true
    },   
    // { 
    //   path: url +'proyectos/', 
    //   name: 'proyectos',
    //   component: Proyectos,
    //   props: true
    // }, 
    { 
      path: url + 'proyectos/:slug', 
      redirect: { name: 'proyecto' }
    }, 
    { 
      path: url +'proyectos/', 
      redirect: { name: 'inicio' }
    },  
    { 
      path: url +'articulos/:slug', 
      name: 'articulo',
      component: Articulo,
      props: true
    },
    { 
      path: url +'luderia', 
      name: 'luderia',
      component: Luderia,
      props: true      
    },
    { 
      path: url +'ludiculas/:slug', 
      name: 'ludicula',
      component: Ludicula,
      props: true
    },
    { 
      path: url +'ludiculas', 
      name: 'ludiculas',
      component: Ludiculas,
      props: true      
    },
    { path: url +':notFound(.*)', component: NotFound },
  ],
  scrollBehavior: function(to, from, savedPosition) {
    //console.log("scroll: ")
   // console.log("to: ", to)
    //console.log("from: ", from) 

    if (savedPosition) {
      //console.log('saved position', savedPosition)
      return savedPosition
    }
    if (to.hash) {
      //console.log('to hash')
      return {
        el: to.hash,
        behabior: 'smooth' 
      }
    } 
    if (to == from) {
     // console.log("Equals")
      if (to.name == "inicio" || to.name == "encuentro" ) {
      //if (to.name == "inicio" ) {
        //console.log("inicio/encuentro")
        goSectionMixin.methods.scrollToSectionRouter(to.params.section)
      }
     // console.log('no inicio ni encuentro')
    }
    // if (to.name == "articulo" || from.name == "articulo") {
    //  // console.log("Vengo o voy a artículo, refrescar")
    //   location.reload()
    // }
  },
})

export default router